import $http from '../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Obtener empresas.
 */
export async function fetchCompanies({commit, state}, reset_company = false) {

    commit('dashboard/load', true, {root: true});

    if (reset_company) {
        commit('setCompanyIdToParams', null);
        commit('resetProducts');
    }

    let params = {
        product_id: state.product.id
    };

    await $http.get('company-by-provider-id/' + state.params.provider_id, {params})
        .then((response) => {
            commit('setCompanies', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener fabricantes.
 */
export async function fetchManufacturers({commit, state, rootState}, name) {

    if (!rootState.dashboard.loading && name.length >= 3) {

        let params = {
            nombre: name
        };

        commit('dashboard/load', true, {root: true});
        await $http.get('/fabricantes', {params})
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('setManufacturers', response.data.fabricantes);
            })
            .catch(() => {
                commit('dashboard/load', false, {root: true});
                console.warn('No se encontraron fabricantes con el nombre especificado');
            });
    }
}

/**
 * Obtener fabricantes.
 */
export async function fetchManufacturersForm({commit, state, rootState}, name) {

    if (!rootState.dashboard.loading && name.length >= 3) {

        let params = {
            nombre: name
        };

        commit('dashboard/load', true, {root: true});
        await $http.get('/fabricantes', {params})
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('setManufacturersForm', response.data.fabricantes);
            })
            .catch(() => {
                commit('dashboard/load', false, {root: true});
                console.warn('No se encontraron fabricantes con el nombre especificado');
            });
    }
}

/**
 * Obtener estados de FDS.
 */
export async function fetchFdsStates({commit, state}) {
    if (!state.fds_states.length) {
        commit('dashboard/load', true, {root: true});
        await $http.get('controles/16')
            .then((response) => {
                commit('setFdsStates', response.data);
                commit('dashboard/load', false, {root: true});
            }).catch(error => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener tipos adjuntos.
 */
export async function fetchTypes({commit, state}) {
    if (!state.types.length) {
        commit('dashboard/load', true, {root: true});
        await $http.get('controles/14')
            .then((response) => {
                commit('setTypes', response.data);
                commit('dashboard/load', false, {root: true});
            }).catch(error => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener lenguajes.
 */
export async function fetchLanguages({commit, state}) {
    if (!state.languages.length) {
        commit('dashboard/load', true, {root: true});
        await $http.get('controles/10')
            .then((response) => {
                commit('setLanguages', response.data);
                commit('dashboard/load', false, {root: true});
            }).catch(error => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener producto.
 */
export async function getProduct({commit, state}, id) {
    commit('dashboard/load', true, {root: true});
    await $http.post('adm_productos/mostrar/' + id)
        .then((response) => {

            let product = null;

            if (response.data.producto && response.data.producto[0]) {
                product = response.data.producto[0];
            }

            if (product) {
                if (product.fabricante) {
                    commit('setManufacturersForm', [product.fabricante]);
                }

                commit('setProduct', product);
                commit('setEditing', true);
                commit('setStepToModal', 0);
                commit('setShowToModal', true);
            }
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Editar producto.
 */
export async function editProduct({commit, state}) {
    commit('dashboard/load', true, {root: true});
    await $http.put('adm_productos/editar/' + state.product.id, state.product)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener producto.
 */
export async function getAttachment({commit, state}) {
    commit('dashboard/load', true, {root: true});

    let params = {
        page: 1,
        perPage: 1,
        estado: [1]
    };

    await $http.get('adm_productos/adjuntos/' + state.product.id, {params})
        .then((response) => {
            if (response.data.data.data && response.data.data.data[0]) {
                commit('setAttachment', response.data.data.data[0]);
            }
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener producto.
 */
export async function editAttachment({commit, state}) {
    commit('dashboard/load', true, {root: true});

    let form_data = new FormData();

    for (let key in state.attachment) {
        
        if (key == 'fechavencimiento' && !state.attachment[key]) {
            continue;
        }

        form_data.append(key, state.attachment[key]);
    }

    await $http.post('adm_productos/adjuntos/editar/' + state.attachment.id, form_data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Guardar producto.
 */
export async function saveProduct({state, commit}) {
    return new Promise(async (resolve, reject) => {
        const moment = require('moment');

        let form_data = state.product;

        form_data.doc_sga = state.attachment.tipo === 154 && (state.attachment.idioma === 137 || state.attachment.idioma === 138) ? 160 : 161;

        if (form_data.doc_etiqueta === 160) {
            form_data.fecha_etiqueta = moment().format('YYYY-MM-DD');
        }

        commit('dashboard/load', true, {root: true});

        await $http.post('adm_productos/crear', form_data)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                resolve(response.data.Idproducto);
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                reject(error);
            });
    });
}

/**
 * Guardar adjunto.
 */
export async function saveAttachment({commit, state}, product_id) {

    let form_data = new FormData();

    for (let key in state.attachment) {
        form_data.append(key, state.attachment[key]);
    }

    return new Promise(async (resolve, reject) => {

        commit('dashboard/load', true, {root: true});

        await $http.post(`adm_productos/adjuntos/crear/${product_id}`, form_data)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                resolve(response.data);
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                reject(error);
            });
    });
}

/**
 * Asociar empresas al producto.
 */
export async function associateCompanies({commit, state}, product_id) {

    let data = {
        product_id,
        provider_id: state.params.provider_id,
        companies: []
    };

    state.companies.map(c => {
        if (c.selected) {
            data.companies.push(c);
        }
    });

    commit('dashboard/load', true, {root: true});

    await $http.post('company-providers-products', data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });

}

/**
 * Obtener productos.
 */
export async function fetchProducts({commit, state}, reset_page = false) {

    if (reset_page) {
        commit('setParamsToPage', 1);
    }

    let params = state.params;

    commit('dashboard/load', true, {root: true});

    await $http.get('company-providers-products', {params})
        .then((response) => {
            commit('setProducts', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener proveedores.
 */
export async function fetchProviders({state, commit}) {

    commit('dashboard/load', true, {root: true});

    let params = {
        paginate: 0,
    };

    await $http.get('/providers', {params})
        .then((response) => {
            commit('setProviders', response.data.data);
        })
        .catch((error) => {
            this.$swal({
                position: 'center',
                icon: 'error',
                title: 'Error al cargar fabricantes: ' + error,
                showConfirmButton: false,
                timer: 1500
            });
        });

    commit('dashboard/load', false, {root: true});
}

/**
 * Descargar un adjunto.
 */
export async function downloadAttachment({commit, state}) {

    let name_file = state.attachment.url.split('/').pop();

    commit('dashboard/load', true, {root: true});

    await $http({
        url: 'adm_productos/adjuntos/download/' + state.product.id,
        method: 'POST',
        responseType: 'blob',
        data: state.attachment
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        let blob = new Blob([response.data], {
            'type': 'application/octet-stream'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = name_file;
        document.body.append(link);
        link.click();
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.error,
            showConfirmButton: true,
            timer: 5000
        });
    });
}

/**
 * Cambiar estado imagen
 */
export async function deleteAttachment({commit, state, dispatch}, imagen) {

    await Swal.fire({
        title: 'Eliminar adjunto',
        text: '¿Está seguro de eliminar el adjunto?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si'
    }).then(async (result) => {
        if (result.value) {
            commit('dashboard/load', true, {root: true});
            await $http.post(`adm_productos/adjuntos/cambiar-estado/${state.attachment.id}`)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                })
                .catch((error) => {
                    commit('dashboard/load', false, {root: true});
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: error.message + '<br> ' + error.errors,
                        showConfirmButton: true,
                        timer: 5000
                    });
                });
        }
    });
}
